import store from '../store'
/**
 * 答案逻辑操作：跳转
 * @param {*} oper
 * @returns
 */
const ifLogicJump = (logicJumpType) => {
  return logicJumpType === '1'
}
/**
 * 答案逻辑操作：中止
 * @param {*} oper
 * @returns
 */
const ifLogicSuspend = (logicJumpType) => {
  return logicJumpType === '2'
}
/**
 * 答案逻辑操作：圈选
 * @param {*} oper
 * @returns
 */
const ifLogicSelect = (logicJumpType) => {
  return logicJumpType === '3'
}
/**
 * 答案逻辑操作：赋值
 * @param {*} oper
 * @returns
 */
const ifLogicAssign = (logicJumpType) => {
  return logicJumpType === '4'
}
/**
 * 答案逻辑操作：匿名答卷
 * @param {*} oper
 * @returns
 */
const ifAnonymousAnswer = (logicJumpType) => {
  return logicJumpType === '5'
}

/**
 * 答案逻辑操作：无效选项
 * @param {*} oper
 * @returns
 */
const ifInvalidOption = (logicJumpType) => {
  return logicJumpType === '6'
}

/**
 * 答题逻辑处理
 * @param {*} Logic
 * @param {*} langMap
 * @param {*} actionType
 * @returns
 */
const logic = async function (Logic, langMap, actionType) {
  // console.log('---------logic---------')
  const {questionList, currentPage, $util: util, userInfo, custQuote} = this
  this.isSuspend = '0' // 中止
  let hasTiaozhuanLogic = false // 存在跳转逻辑：false
  let matrixOrderIdArr = [] // TODO：针对矩阵题存储排序id，然后取最大id
  let execQuBeforLogicsNew = false // 圈选逻辑时执行时不能跳过题前显示逻辑

  // 循环所有组，处理组前逻辑（题组显示逻辑）
  // for (const groupItem of this.groupList) {
  for (let i=0; i<this.groupList.length; i++) {
    let groupVisibility = true
    if (!util.isNull(this.groupList[i].quGroupLogicsNew)) {
      groupVisibility = util.ifLogicGroup.call(this, this.groupList[i].quGroupLogicsNew, userInfo, questionList, Logic, custQuote)
    }

    // 设置所有题目分组的可见性
    // for (const groupQuestion of this.groupList[i].questionList) {
    for (let j=0; j<this.groupList[i].questionList.length; j++) {
      this.groupList[i].questionList[j].groupVisibility = groupVisibility
    }
  }

  // 循环该页所有题目，处理内容逻辑、多语言、引用、提前逻辑、答案逻辑
  let filterIgnoreQuestionList = []
  if(actionType === 'init'){
    console.log('-------init-------', store.getters.userPage)
    if ([0, 1].includes(store.getters.userPage)) {
      // 非全量
      filterIgnoreQuestionList = questionList.filter(qu => (qu.page >= this.prePageNo && qu.page <= this.nextPageNo) && !qu.ignore)
    } else {
      // 全量
      filterIgnoreQuestionList = questionList.filter(qu => !qu.ignore)
      
      // TODO: 断点续答后矩阵题中带引用、题前显示逻辑的不生效
      setTimeout(() => {
        this.logic('answer')
      })
    }
  }else if(actionType === 'answer'){
    console.log('-------answer-------')
    filterIgnoreQuestionList = questionList.filter(qu => (qu.page >= this.prePageNo && qu.page <= this.nextPageNo) && !qu.ignore)
  }else if(actionType === 'pageUpDown'){
    console.log('-------pageUpDown-------')
    filterIgnoreQuestionList = questionList.filter(qu => (qu.page >= this.prePageNo && qu.page <= this.nextPageNo) && !qu.ignore)
  }else{
    console.log('-------other-------')
    filterIgnoreQuestionList = questionList.filter(qu => !qu.ignore)
  }

  for (let i = 0; i < filterIgnoreQuestionList.length; i++) {
    // allOrderById：题目的序号
    // crtDescIndex：当前子问题索引
    // descList：子问题
    const { allOrderById } = filterIgnoreQuestionList[i]

    // 处理题干内容逻辑
    filterIgnoreQuestionList[i].syncContentLogic && filterIgnoreQuestionList[i].syncContentLogic(questionList, userInfo, Logic, custQuote)
    // 处理多语言转换
    filterIgnoreQuestionList[i].syncLang && filterIgnoreQuestionList[i].syncLang(langMap)
    // 处理题目中的“引用”内容
    filterIgnoreQuestionList[i].syncQuoteTitle && filterIgnoreQuestionList[i].syncQuoteTitle(questionList, userInfo, custQuote)

    // 不存在跳转时，该题的后续所有题目设置为可见
    if (!hasTiaozhuanLogic) {
      const afterQuestionList = questionList.filter(qu => qu.allOrderById > allOrderById)
      for (let j = 0; j < afterQuestionList.length; j++) {
        afterQuestionList[j].visibility = true
      }
    }

    // 处理答案逻辑
    // toQuId：目标题目id
    // logicJumpType：逻辑操作（1：跳转；2：中止；3：自动圈选；4：自动赋值 5：匿名答卷 6：设置无效选项）
    // TODO: 两个for循环可以进行合并 - by wangze
    let quLogics = filterIgnoreQuestionList[i].quLogicsNew
    if (!util.isNull(quLogics)) {
      // 清除答案逻辑“圈选”和“赋值”的数据、清楚匿名答卷设置
      // for (const quLogic of quLogics) {
      for (let m=0; m<quLogics.length; m++) {
        // 遍历所有操作
        // for (const oper of quLogics[m].to) {
        for (let n=0; n<quLogics[m].to.length; n++) {
          const { toQuId, logicJumpType, toSubQuId } = quLogics[m].to[n]

          // 取消匿名答卷设置
          if (ifAnonymousAnswer(logicJumpType)) {
            this.resetAnonymousAnswer()
            continue
          }

          // 过滤掉非“圈选”和”赋值“和“无效选项”的，或者没有目标问题ID的
          if (!(ifLogicSelect(logicJumpType) || ifLogicAssign(logicJumpType) || ifInvalidOption(logicJumpType)) || !toQuId) {
            continue
          }
          // 获取目标问题
          let toQuItem
          if (toSubQuId) {
            // 圈选矩阵题
            toQuItem = this.getChenQuItem(toQuId, toSubQuId)
          } else {
            // 圈选非矩阵题
            toQuItem = this.getQuItem(toQuId)
          }
          if (toQuItem && filterIgnoreQuestionList[i].page >= currentPage && actionType !== 'pageUpDown') {
            
            /**
             * 清除目标问题的数据
             * toQuItem.allOrderById > Number(sessionStorage.getItem('allOrderByIdStash'))
             * TODO: 一页纸型答题带圈选逻辑的，需清除当前题后的题
            */
            if (actionType !== 'bot' && toQuItem.allOrderById > Number(sessionStorage.getItem('allOrderByIdStash'))) {
              if (ifLogicSelect(logicJumpType) || ifLogicAssign(logicJumpType)) {
                this.clearLogicValue(quLogics[m].to[n], toQuItem)
              }
              if (ifInvalidOption(logicJumpType)) {
                this.clearInvalidOption(quLogics[m].to[n], toQuItem)
              }
            } else if (actionType === 'bot' && (ifLogicAssign(logicJumpType) || ifInvalidOption(logicJumpType)) && toQuItem.allOrderById > Number(sessionStorage.getItem('allOrderByIdStash'))) {
              if (ifLogicAssign(logicJumpType)) {
                this.clearLogicValue(quLogics[m].to[n], toQuItem)
              }
              if (ifInvalidOption(logicJumpType)) {
                this.clearInvalidOption(quLogics[m].to[n], toQuItem)
              }
            }
          }
        }
      }

      // 执行答案逻辑
      // for (const quLogic of quLogics) {
      for (let m=0; m<quLogics.length; m++) {
        // 验证逻辑是否符合
        if (!util.ifLogicGroup.call(this, quLogics[m].logics, userInfo, questionList, Logic, custQuote)) {
          continue
        }

        // 遍历所有需要执行的操作
        // for (const oper of quLogics[m].to) {
        for (let n=0; n<quLogics[m].to.length; n++) {
          // console.log(item, oper)
          const { logicJumpType, toQuId, toSubQuId } = quLogics[m].to[n]
          // 跳转
          if (ifLogicJump(logicJumpType)) {
            // 获取跳转的目标问题
            const toQuItem = this.getQuItem(toQuId)
            if (!toQuItem) {
              continue
            }

            // TODO: 收集统一矩阵题allOrderById
            if (allOrderById && matrixOrderIdArr.indexOf(allOrderById) < 0) {
              matrixOrderIdArr.push(allOrderById)
            }

            let filterArr = []
            if (['RadioBoxGroup', 'CheckBoxGroup'].includes(filterIgnoreQuestionList[i].elementType)) {
              // 矩阵题
              let maxVal = matrixOrderIdArr.length ? Math.max(...matrixOrderIdArr) : allOrderById
              filterArr = questionList.filter(qu => qu.allOrderById > maxVal && qu.allOrderById < toQuItem.allOrderById)
            } else {
              // 非矩阵题
              filterArr = questionList.filter(qu => qu.allOrderById > allOrderById && qu.allOrderById < toQuItem.allOrderById)
            }
            for (let filterArrI = 0; filterArrI < filterArr.length; filterArrI++) {
              hasTiaozhuanLogic = true
              
              // TODO: 矩阵题收集统一allOrderById
              if (['RadioBoxGroup', 'CheckBoxGroup'].includes(filterArr[filterArrI].elementType) && filterArr[filterArrI].id === filterIgnoreQuestionList[i].id) {
                if (allOrderById && matrixOrderIdArr.indexOf(filterArr[filterArrI].allOrderById) < 0) {
                  matrixOrderIdArr.push(filterArr[filterArrI].allOrderById)
                }
              } else {
                filterArr[filterArrI].visibility = false
                // 矩阵题清空
                if (filterArr[filterArrI].descList) {
                  filterArr[filterArrI].descList.forEach(item => {
                    if (Array.isArray(item.value)) {
                      item.value = []
                    } else {
                      item.value = ''
                    }
                  })
                }
              }
                  
              if (Array.isArray(filterArr[filterArrI].value)) {
                filterArr[filterArrI].value.splice(0, filterArr[filterArrI].value.length)
              } else {
                filterArr[filterArrI].value = ''
              }
            }
            if (hasTiaozhuanLogic) {
              // for (const afterQu of questionList.filter(qu => qu.allOrderById > toQuItem.allOrderById)) {
              const afterQuListFilter = questionList.filter(qu => qu.allOrderById > toQuItem.allOrderById)
              for (let o=0; o<afterQuListFilter.length; o++) {
                // 略过默认就隐藏的题目
                if (!afterQuListFilter[o].quVisibility) {
                  continue
                }

                // 处理题前逻辑（显示逻辑）
                afterQuListFilter[o].visibility = true
                if (!util.isNull(afterQuListFilter[o].quBeforLogicsNew)) {
                  afterQuListFilter[o].visibility = util.ifLogicGroup.call(this, afterQuListFilter[o].quBeforLogicsNew, userInfo, questionList, Logic, custQuote)

                  if (afterQuListFilter[o].visibility === false && afterQuListFilter[o].page > currentPage) {
                    if (Array.isArray(afterQuListFilter[o].value)) {
                      afterQuListFilter[o].value.splice(0, afterQuListFilter[o].value.length)
                    } else {
                      afterQuListFilter[o].value = ''
                    }
                  }
                }

                // 处理选项显示逻辑
                if (afterQuListFilter[o].optionList && afterQuListFilter[o].optionList.length > 0) {
                  // for (const afterQuListFilter[o].optionList[p] of afterQuListFilter[o].optionList) {
                  for (let p=0; p<afterQuListFilter[o].optionList.length; p++) {
                    afterQuListFilter[o].optionList[p].visibility = true
                    if (!util.isNull(afterQuListFilter[o].optionList[p].optionBeforLogicsNew)) {
                      afterQuListFilter[o].optionList[p].visibility = util.ifLogicGroup.call(this, afterQuListFilter[o].optionList[p].optionBeforLogicsNew, userInfo, questionList, Logic, custQuote)
                    }
                  }
                }

                // 处理子问题显示逻辑
                if (afterQuListFilter[o].descList && afterQuListFilter[o].descList.length > 0) {
                  // for (const descItem of afterQuListFilter[o].descList) {
                  for (let p=0; p<afterQuListFilter[o].descList.length; p++) {
                    afterQuListFilter[o].descList[p].visibility = true
                    if (!util.isNull(afterQuListFilter[o].descList[p].quBeforLogicsNew)) {
                      afterQuListFilter[o].descList[p].visibility = util.ifLogicGroup.call(this, afterQuListFilter[o].descList[p].quBeforLogicsNew, userInfo, questionList, Logic, custQuote)
                      if (afterQuListFilter[o].descList[p].visibility === false && afterQuListFilter[o].page > currentPage) {
                        if (Array.isArray(afterQuListFilter[o].descList[p].value)) {
                          afterQuListFilter[o].descList[p].value.splice(0, afterQuListFilter[o].descList[p].value.length)
                        } else {
                          afterQuListFilter[o].descList[p].value = ''
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          // 终止
          if (ifLogicSuspend(logicJumpType)) {
            // TODO: 收集统一矩阵题allOrderById
            if (allOrderById && matrixOrderIdArr.indexOf(allOrderById) < 0) {
              matrixOrderIdArr.push(allOrderById)
            }

            let afterQuListFilter = []
            if (['RadioBoxGroup', 'CheckBoxGroup'].includes(filterIgnoreQuestionList[i].elementType)) {
              // 矩阵题
              let maxVal = matrixOrderIdArr.length ? Math.max(...matrixOrderIdArr) : allOrderById
              afterQuListFilter = questionList.filter(qu => qu.allOrderById > maxVal)
            } else {
              // 非矩阵题
              afterQuListFilter = questionList.filter(qu => qu.allOrderById > allOrderById)
            }

            // for (const afterQu of questionList.filter(qu => qu.allOrderById > allOrderById)) {
            for(let o=0; o<afterQuListFilter.length; o++) {
              
              // TODO: 矩阵题收集统一allOrderById
              if (['RadioBoxGroup', 'CheckBoxGroup'].includes(afterQuListFilter[o].elementType) && afterQuListFilter[o].id === filterIgnoreQuestionList[i].id) {
                if (allOrderById && matrixOrderIdArr.indexOf(afterQuListFilter[o].allOrderById) < 0) {
                  matrixOrderIdArr.push(afterQuListFilter[o].allOrderById)
                }
              } else {
                afterQuListFilter[o].visibility = false
                // 矩阵题清空
                if (afterQuListFilter[o].descList) {
                  afterQuListFilter[o].descList.forEach(item => {
                    if (Array.isArray(item.value)) {
                      item.value = []
                    } else {
                      item.value = ''
                    }
                  })
                }
              }

              if (Array.isArray(afterQuListFilter[o].value)) {
                afterQuListFilter[o].value.splice(0, afterQuListFilter[o].value.length)
              } else {
                afterQuListFilter[o].value = ''
              }
            }
            this.isSuspend = '1'
            return
          }
          // 自动圈选 自动赋值 设置无效选项
          if (ifLogicSelect(logicJumpType) || ifLogicAssign(logicJumpType) || ifInvalidOption(logicJumpType)) {
            // 获取目标题目
            let toQuItem
            if (toSubQuId) {
              // 圈选矩阵题
              toQuItem = this.getChenQuItem(toQuId, toSubQuId)
            } else {
              // 圈选非矩阵题
              toQuItem = this.getQuItem(toQuId)
            }
            
            /**
             * toQuItem.allOrderById > Number(sessionStorage.getItem('allOrderByIdStash'))
             * TODO: 一页纸型答题带圈选逻辑的，需圈选当前题后的题
            */
            if (toQuItem && actionType !== 'bot' && toQuItem.allOrderById > Number(sessionStorage.getItem('allOrderByIdStash'))) {
              execQuBeforLogicsNew = true
              // 设置答案
              if (ifLogicSelect(logicJumpType) || ifLogicAssign(logicJumpType)) {
                this.setLogicValue(quLogics[m].to[n], toQuItem)
              }
              if (ifInvalidOption(logicJumpType)) {
                this.setInvalidOption(quLogics[m].to[n], toQuItem)
              }
            } else if (toQuItem && actionType === 'bot' && (ifLogicAssign(logicJumpType) || ifInvalidOption(logicJumpType)) && toQuItem.allOrderById > Number(sessionStorage.getItem('allOrderByIdStash'))) {
              if (ifLogicAssign(logicJumpType)) {
                this.setLogicValue(quLogics[m].to[n], toQuItem)
              }
              if (ifInvalidOption(logicJumpType)) {
                this.setInvalidOption(quLogics[m].to[n], toQuItem)
              }
            }
          } else {
            execQuBeforLogicsNew = false
          }

          // 匿名答卷
          if (ifAnonymousAnswer(logicJumpType)) {
            this.setAnonymousAnswer()
          }
        }
      }
    }

    if (hasTiaozhuanLogic && (!execQuBeforLogicsNew || (actionType === 'pageUpDown' || actionType === 'bot'))) {
      continue
    }

    // 题前逻辑(题目显示逻辑)
    // 如果是第一题 也校验逻辑
    let ifShowAllOrderById = 0
    if (currentPage === 1) {
      ifShowAllOrderById = -1
    } else {
      ifShowAllOrderById = allOrderById
    }
    const showQuListFilter = questionList.filter(qu => qu.allOrderById >= ifShowAllOrderById)

    // for (const afterQu of questionList.filter(qu => qu.allOrderById > ifShowAllOrderById)) {
    for (let m=0; m<showQuListFilter.length; m++) {
      // 略过默认就隐藏的题目
      if (!showQuListFilter[m].quVisibility) {
        continue
      }

      // 处理题前逻辑（显示逻辑）
      showQuListFilter[m].visibility = true
      if (!util.isNull(showQuListFilter[m].quBeforLogicsNew)) {
        const { visibility, custValidResult } = util.ifLogicGroup.call(this, showQuListFilter[m].quBeforLogicsNew, userInfo, questionList, Logic, custQuote, true)
        showQuListFilter[m].visibility = visibility

        if (custValidResult === false) {
          if (Array.isArray(showQuListFilter[m].value)) {
            showQuListFilter[m].value.splice(0, showQuListFilter[m].value.length)
          } else {
            showQuListFilter[m].value = ''
          }
        }
      }

      // 处理选项显示逻辑
      if (showQuListFilter[m].optionList && showQuListFilter[m].optionList.length > 0) {
        // for (const showQuListFilter[m].optionList[n] of showQuListFilter[m].optionList) {
        for (let n=0; n<showQuListFilter[m].optionList.length; n++) {
          showQuListFilter[m].optionList[n].visibility = true
          if (!util.isNull(showQuListFilter[m].optionList[n].optionBeforLogicsNew)) {
            showQuListFilter[m].optionList[n].visibility = util.ifLogicGroup.call(this, showQuListFilter[m].optionList[n].optionBeforLogicsNew, userInfo, questionList, Logic, custQuote)
          }
        }
      }

      // 处理子问题显示逻辑
      if (showQuListFilter[m].descList && showQuListFilter[m].descList.length > 0) {
        // for (const descItem of showQuListFilter[m].descList) {
        for (let n=0; n<showQuListFilter[m].descList.length; n++) {
          showQuListFilter[m].descList[n].visibility = true
          if (!util.isNull(showQuListFilter[m].descList[n].quBeforLogicsNew)) {
            const { visibility, custValidResult } = util.ifLogicGroup.call(this, showQuListFilter[m].descList[n].quBeforLogicsNew, userInfo, questionList, Logic, custQuote, true)
            showQuListFilter[m].descList[n].visibility = visibility

            if (custValidResult === false) {
              if (Array.isArray(showQuListFilter[m].descList[n].value)) {
                showQuListFilter[m].descList[n].value.splice(0, showQuListFilter[m].descList[n].value.length)
              } else {
                showQuListFilter[m].descList[n].value = ''
              }
            }
          }
        }
      }
    }
  }
}
export default logic



// WEBPACK FOOTER //
// ./src/third/logic.js